var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',{staticClass:"mt-3"},_vm._l((_vm.calendars),function(calendar){return _c('b-list-group-item',{key:calendar.id,style:({ 'color': calendar.bgColor })},[_vm._v(" "+_vm._s(calendar.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }